/* 
In conjunction with .ss-htmleditorfield-file.embed styling in /app/scss/global/_layout.scss 
*/

$(document).ready(function () {

    if ($('.e-content').length > 0 || $('.page__content').length > 0) {
        setDataAttributes();
        setInitialSizing();
        resizeEmbeds();

        $(window).on('resize', function () {
            resizeEmbeds();
        });
    }
});

// calculate the aspect ratio by grabbing the inner iframe's original width and height and set ratio as a data attribute
// if a custom overwritten width has been set use this otherwise use the original width, set width as a data attribute
function setDataAttributes() {
    $('iframe').each(function () {
        const iframeWrapper = $(this).parent();
        iframeWrapper.css('max-width', 'auto'); // this is set in place to not overwrite the custom set width

        var originalWidth = iframeWrapper.children('iframe').css('width');
        var originalHeight = iframeWrapper.children('iframe').css('height');

        var aspectRatio = parseInt(originalHeight) / parseInt(originalWidth);
        iframeWrapper.attr({ 'data-ratio': aspectRatio });

        var overWrittenWidth = iframeWrapper.css('width');

        if (parseInt(overWrittenWidth)) {
            iframeWrapper.attr({ 'data-width': overWrittenWidth });
        } else {
            iframeWrapper.attr({ 'data-width': originalWidth });
        }
    });
}

// get the width and calculate the height from the width and aspect ratio data attributes set in the previous function
// set the width and height of the embed, replace the inner iframe width and height with a full 100%
// apply a clear: both to the trailing element if video is set by itself
function setInitialSizing() {
    $('iframe').each(function () {
        const iframeWrapper = $(this).parent();
        var trueAspectRatio = iframeWrapper.data('ratio');
        var trueWidth = (parseInt(iframeWrapper.data('width')));
        var trueHeight = Math.floor(trueWidth * trueAspectRatio);

        iframeWrapper.css('width', trueWidth + 'px');
        iframeWrapper.css('height', trueHeight + 'px');
        iframeWrapper.children('iframe').css('width', '100%');
        iframeWrapper.children('iframe').css('height', '100%');

        iframeWrapper.css('max-width', '100%');

        if (iframeWrapper.hasClass('leftAlone') || iframeWrapper.hasClass('center') || iframeWrapper.hasClass('rightAlone')) {
            iframeWrapper.next().css('clear', 'both');
        }
    }); 
}

// grab the original width as seen in the data atrribute
// grab the current width
// grab the aspect ratio from the data attribute
// if the current is smaller than the original width, adjust the height by setting it based on the aspect ratio
// add/adjust padding to the bottom if a caption is present
function resizeEmbeds() {
    $('iframe').each(function () {
        const iframeWrapper = $(this).parent();
        var attributeAspectRatio = iframeWrapper.data('ratio');
        var currentWidth = (parseInt(iframeWrapper.css('width')));
        var attributeWidth = (parseInt(iframeWrapper.data('width')));

        if (currentWidth < attributeWidth) {
            var newHeight = Math.floor(currentWidth * attributeAspectRatio);
            iframeWrapper.css('height', newHeight + 'px');
        }

        if (iframeWrapper.find('.caption').length > 0) {
            var captionHeight = iframeWrapper.find('.caption').height();
            iframeWrapper.css('padding-bottom', captionHeight + 17 + 'px');
        }
    }); 
}